import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, cloneElement } from 'react';
import classNames from 'classnames';
import { Button } from 'module-tsl-ui-elements';
import PropTypes from 'prop-types';

var Collapsible = /*#__PURE__*/function (_Component) {
  _inherits(Collapsible, _Component);

  var _super = _createSuper(Collapsible);

  function Collapsible(props) {
    var _this;

    _classCallCheck(this, Collapsible);

    _this = _super.call(this, props);
    _this.state = {
      controlled: typeof props.toggled === 'boolean',
      toggled: !!props.toggled,
      maxHeight: 0,
      transitionEndToggled: false,
      needSecondRender: !!props.initialHeight
    };
    return _this;
  }

  _createClass(Collapsible, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.toggled) {
        this.setMaxHeight();
      }

      if (this.state.needSecondRender) {
        this.doSecondRender();
      }

      this._content.addEventListener('transitionend', function () {
        _this2.setState(function (prevState) {
          return {
            transitionEndToggled: prevState.toggled
          };
        });
      }, false);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this3 = this;

      if (newProps.toggled !== this.state.toggled && this.state.controlled) {
        this.setState({
          transitionEndToggled: false
        }, function () {
          _this3.setState({
            toggled: newProps.toggled
          });
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var maxHeight = this._maxHeightWrapper.offsetHeight;

      if (this.state.maxHeight !== maxHeight) {
        this.setMaxHeight(maxHeight);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttledEvent);
    }
  }, {
    key: "setMaxHeight",
    value: function setMaxHeight(passedMaxHeight) {
      var maxHeight = passedMaxHeight || this._maxHeightWrapper.offsetHeight;
      this.setState({
        maxHeight: maxHeight
      });
    }
  }, {
    key: "doSecondRender",
    value: function doSecondRender() {
      this.setState({
        needSecondRender: false
      });
    }
  }, {
    key: "toggle",
    value: function toggle(evt) {
      var _this4 = this;

      evt.preventDefault();
      var toggled = !this.state.toggled;

      var end = function end() {
        return _this4.props.onToggled && _this4.props.onToggled(toggled);
      };

      var after = function after() {
        return _this4.setState({
          toggled: toggled
        }, end);
      };

      this.setState({
        transitionEndToggled: false
      }, after);
    }
  }, {
    key: "shouldNotRenderToggler",
    value: function shouldNotRenderToggler() {
      if (this.state.needSecondRender) return false;
      var _this$props = this.props,
          initialHeight = _this$props.initialHeight,
          initialHeightThreshold = _this$props.initialHeightThreshold,
          forceToggle = _this$props.forceToggle;
      if (forceToggle) return false;
      var calculatedInitialHeight = initialHeight ? initialHeightThreshold + initialHeight : 0;
      return !!calculatedInitialHeight && !this._maxHeightWrapper || !!calculatedInitialHeight && this._maxHeightWrapper && this._maxHeightWrapper.offsetHeight <= calculatedInitialHeight;
    }
  }, {
    key: "renderToggler",
    value: function renderToggler(toggler, disabled) {
      var _this5 = this;

      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';

      if (this.shouldNotRenderToggler()) {
        return null;
      }

      if (typeof toggler === 'string' && toggler.length > 0) {
        return /*#__PURE__*/React.createElement(Button, {
          className: "tes-collapsible__toggler ".concat(position === 'bottom' ? ' tes-collapsible__toggler--bottom' : ''),
          onClick: function onClick(evt) {
            return !disabled && _this5.toggle(evt);
          },
          disabled: disabled,
          type: "button"
        }, toggler);
      }

      return /*#__PURE__*/cloneElement(toggler, _objectSpread(_objectSpread({}, toggler.props), {}, {
        onClick: function onClick(evt) {
          return !disabled && _this5.toggle(evt);
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$state = this.state,
          toggled = _this$state.toggled,
          maxHeight = _this$state.maxHeight,
          transitionEndToggled = _this$state.transitionEndToggled;
      var _this$props2 = this.props,
          toggler = _this$props2.toggler,
          togglerToggled = _this$props2.togglerToggled,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          togglerBottom = _this$props2.togglerBottom,
          togglerBottomToggled = _this$props2.togglerBottomToggled,
          initialHeight = _this$props2.initialHeight;
      var shouldNotRenderToggler = this.shouldNotRenderToggler();
      var collapsedMaxHeight = initialHeight || 0;
      var maxHeightCalculated = toggled ? maxHeight : collapsedMaxHeight;
      var cName = classNames('tes-collapsible', {
        'is--toggled': toggled,
        'is--disabled': disabled,
        'is--toggled-no-overflow': transitionEndToggled
      });
      var style = transitionEndToggled || shouldNotRenderToggler ? {} : {
        maxHeight: maxHeightCalculated
      };
      return /*#__PURE__*/React.createElement("div", {
        className: cName
      }, !!toggler && this.renderToggler(toggled && togglerToggled ? togglerToggled : toggler, disabled), /*#__PURE__*/React.createElement("div", {
        className: "tes-collapsible__content ".concat(!shouldNotRenderToggler ? 'tes-collapsible__content--with-toggler' : ''),
        style: style,
        ref: function ref(content) {
          _this6._content = content;
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: function ref(maxHeightWrapper) {
          _this6._maxHeightWrapper = maxHeightWrapper;
        }
      }, children)), togglerBottom && this.renderToggler(toggled && togglerBottomToggled ? togglerBottomToggled : togglerBottom, disabled, 'bottom'));
    }
  }]);

  return Collapsible;
}(Component);

Collapsible.displayName = "Collapsible";
// Used in container
Collapsible.propTypes = {
  /**
   * Note: `toggled` can't be set as default prop, coz based on it being passed as a prop
   * or not, we infer whether the component is being controlled (the developer sets its `toggled` state) or not.
   *
   * See the check on the constructor: `controlled: typeof props.toggled === 'boolean'`
   *
   */
  // eslint-disable-next-line react/require-default-props
  toggled: PropTypes.bool,
  disabled: PropTypes.bool,
  toggler: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  togglerToggled: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  togglerBottom: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  togglerBottomToggled: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node,
  onToggled: PropTypes.func,
  initialHeight: PropTypes.number,
  initialHeightThreshold: PropTypes.number,
  forceToggle: PropTypes.bool
};
Collapsible.defaultProps = {
  disabled: false,
  initialHeightThreshold: 50,
  forceToggle: false,
  toggler: false,
  togglerToggled: false,
  togglerBottom: false,
  togglerBottomToggled: false,
  children: '',
  onToggled: function onToggled() {},
  initialHeight: null
};
export default Collapsible;